export class ArbetsorderDokumentTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        dokument: "Dokument",
        extraInfo: "Extra info",
        skapad: "Skapad",
        skapaAvverkningsdirektiv: "Skapa gällande avverkningsdirektiv",
        skapaApteringspaket: "Skapa apteringsfiler"
    };
}
